import { makeItemId } from "../tools";
import i18n from "../i18n";

i18n.on("languageChanged", (language) => {
  // this code trigger on language change
});

export default function detailsModel(questionList) {
  let details = {};
  details = {
    ...questionList,
    fullQuestion:
      questionList?.fullQuestion ?? i18n.t("create.newSurvey"),
    itemId: questionList?.itemId ?? makeItemId(), // generate a new itemId
    shortQuestion: questionList?.shortQuestion ?? "",
    typeQuestion: questionList?.typeQuestion ?? "container",
    itemExtra: {
      ...(questionList?.itemExtra ?? {}),
      appletName: questionList?.itemExtra?.appletName ?? "applet",
      buttonText: questionList?.itemExtra?.buttonText ?? "",
      appletLabel: questionList?.itemExtra?.appletLabel ?? "applet",
      buttonLabel: questionList?.itemExtra?.buttonLabel ?? "button",
      description: {
        ...(questionList?.itemExtra?.description ?? {}),
        description: questionList?.itemExtra?.description?.description ?? "",
      },
      useAsButton: questionList?.itemExtra?.useAsButton ?? 0,
      interactionType: questionList?.itemExtra?.interactionType ?? 0, // 0 = survey, 1 = button, 2 = applet
      interactionView: questionList?.itemExtra?.interactionView ?? 0, // 1 = curated
      notificationText: questionList?.itemExtra?.notificationText ?? null,
      notificationSoundId: questionList?.itemExtra?.notificationSoundId ?? null,
    },
  };
  if (details?.items) {
    delete details.items;
  }
  return details;
}
